import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchIdentity } from '@office-start/identity-service';
export var fetchUserStorageOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var identity, officeComponentContext, options;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchIdentity()];
            case 1:
                identity = _a.sent();
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 2:
                officeComponentContext = _a.sent();
                if (!officeComponentContext || !identity) {
                    return [2 /*return*/, null];
                }
                options = {
                    correlationId: officeComponentContext.correlationId,
                    getAccessToken: officeComponentContext.getAccessToken,
                    getIdentity: function () { return Promise.resolve(identity); },
                    inMockMode: officeComponentContext.inMockMode,
                    jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                    officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                    workload: officeComponentContext.workload,
                };
                return [2 /*return*/, options];
        }
    });
}); };
//# sourceMappingURL=fetchUserStorageOptions.js.map